import React, { useEffect, useState, useRef } from "react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import IntellipayStoreOnlyMode from "./IntellipayStoreOnlyMode";

export const ModalUpdateIntelliPay = () => {
  const { eventId } = useParams();
  const { user } = useAuthUser();
  const buttonRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const setIsOpenRegister = () => {
    const redirectPath =
      user.role === "university" ? "/university/account" : "/athlete/account";
    window.location.href = redirectPath;
  };

  useEffect(() => {
    if (buttonRef.current) {
      setTimeout(() => {
        buttonRef.current.click();
        setLoading(false);
      }, [4000]);
    }
  }, []);

  return (
    <>
      {loading && (
        <div className="flex absolute top-0 left-0 justify-center items-center h-[100%] w-full bg-black/10">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            size="4x"
            className="text-blue-800"
          />
        </div>
      )}
      <button
        className="ipayfield hidden"
        data-ipayname="submit"
        ref={buttonRef}
      ></button>

      <IntellipayStoreOnlyMode
        userEmail={user.email}
        userId={user.id}
        paymentAmount={0}
        eventId={eventId}
        onRegistrationSuccess={() => {
          setIsOpenRegister();
        }}
        closeAction={true}
        onClose={() => {
          const redirectPath =
            user.role === "university"
              ? "/university/account"
              : "/athlete/account";
          window.location.href = redirectPath;
        }}
      />
    </>
  );
};
